/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

///////////////////////////////////////////////////////////
/////////////////// BAND MATH /////////////////////////////
///////////////////////////////////////////////////////////

import * as Blockly from 'blockly/core';
import 'blockly/python';

Blockly.Blocks['analyse_math_number_overriden'] = {
    init: function () {
        this.setHelpUrl(Blockly.Msg.MATH_NUMBER_HELPURL);
        this.setStyle('bandMath');
        this.appendDummyInput()
            .appendField(new Blockly.FieldNumber('0'), 'NUM');
        this.setOutput(true, 'band_math_expression');
        this.setTooltip(Blockly.Msg.MATH_NUMBER_TOOLTIP);
    }
};